export const consolidateMmyOrVin = function(productsInCart, rootState, typeOfCableSelection) {
    let consolidatedData = {};
    for (let product of productsInCart) {
        let cableSelectionModule = `${product.productKey}${product.offerKey}CableSelection`;
        if (Object.keys(rootState).includes(cableSelectionModule)) {
            let cableData = rootState[cableSelectionModule][typeOfCableSelection.toLowerCase()][`submitted${typeOfCableSelection}Data`];
            for (let cable of cableData) {
                if (cable.customerInput in consolidatedData) {
                    consolidatedData[cable.customerInput].quantity += cable.quantity
                } else {
                    consolidatedData[cable.customerInput] = {cable: cable.cable, quantity: cable.quantity};
                }
            }
        }
    }
    return consolidatedData;
}
